module.exports = __webpack_public_path__ + "static/img/camera-icon.1c2367e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/camera-icon.png
// module id = F5uL
// module chunks = 1